import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ChannelService = {
  getList: async () => {
    try {
      const response = await apiService.get("/channelpartners");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  getUnassignList: async (destinationCountry) => {
    try {
      const params = new URLSearchParams({
        ...(destinationCountry && { destinationCountry }),
      });
      const response = await apiService.get(
        `/channelpartners/universities-unassigned?${params.toString()}`,
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  getAssignList: async () => {
    try {
      const response = await apiService.get(
        "/channelpartners/universities-grouped",
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  create: async (data) => {
    const response = await apiService.post("/channelpartners", data);
    return response.data;
  },
  createAssignUni: async (data) => {
    const response = await apiService.post(
      "/channelpartners/assign-universities",
      data,
    );
    return response.data;
  },
  createUnAssignUni: async (data) => {
    const response = await apiService.post(
      "/channelpartners/unassign-universities",
      data,
    );
    return response.data;
  },
  reOrder: async (data) => {
    const response = await apiService.post(
      "/channelpartners/reorder-universities",
      data,
    );
    return response.data;
  },
  update: async (id, updateddata) => {
    const response = await apiService.put(
      `/channelpartners/${id}`,
      updateddata,
    );
    return response.data;
  },
  getdetails: async (id) => {
    const response = await apiService.get(`/channelpartners/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/channelpartners/${id}`);
    return response.data;
  },
};

export default ChannelService;
